<div #originRef
     (click)="showPopover(originRef)"
     [class.bg-hover]="dropdownOpen"
     class="flex items-center rounded cursor-pointer relative trans-ease-out select-none py-1 px-1 sm:pl-3 hover:bg-hover"
     matRipple>
  <div class="body-1 font-medium leading-snug ltr:mr-3 rtl:ml-3 hidden sm:block" title="{{authService.currentUserValue?.email}}">{{authService.currentUserValue.firstname}} {{authService.currentUserValue?.lastname}}</div>
  @if (user?.photo) {
    <img [src]="user.photo | photo:'/rs:fill:100:100:1/g:no/' | async"
         class="avatar h-9 w-9"
         [alt]="userInitials">
  } @else {
    <div class="rounded-full h-9 w-9 flex items-center justify-center text-primary bg-primary/10 font-semibold">
      {{ userInitials }}
    </div>
  }
</div>
